export type LayoutType = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

// [Note to self: Palak] keep all the height numbeers in config going forward and import from there and same import in the actual UI component.
const getHeightForLayoutType = (type: LayoutType, variation: any) => {
  switch (type) {
    case 1:
      return 409;
    case 2:
      return variation % 2 === 0 ? 224 : 451;
    case 3:
      return variation % 2 === 0 ? 451 : 451;
    case 4:
      return variation % 2 === 0 ? 675 : 675;
    case 5:
      return variation % 2 === 0 ? 675 : 902;
    case 6:
      return variation % 2 === 0 ? 899 : 1126;
    case 7:
      return variation % 2 === 0 ? 1126 : 1126;
    case 8:
      return variation % 2 === 0 ? 1535 : 1535;
    default:
      throw new Error(`type can only be of LayoutType type.`);
  }
};

export default getHeightForLayoutType;
